import Blue from "~/core";

new Blue({
	name: 'Tabs',
	selector: ".tabs",
	setup(tabs) {
		const tabsTriggers = [...tabs.querySelectorAll('.tabs__trigger')];
		const tabsItems = [...tabs.querySelectorAll('.tabs__item')];

		tabsTriggers.forEach(trigger => {
			trigger.addEventListener('click', (e) => {
				const button = trigger.getAttribute('data-tab');
				const tabContent = tabs.querySelector(`.tabs__item[data-item='${button}']`);
				const triggerSibs = [...tabs.querySelectorAll('.tabs__trigger')].filter(item => item != trigger);
				const contentSibs = [...tabs.querySelectorAll('.tabs__item')].filter(item => item != tabContent);
				
				triggerSibs.forEach(sib => {
					sib.classList.remove('is-active');
				});
				
				contentSibs.forEach(sib => {
					sib.classList.remove('is-active');
				});
				
				trigger.classList.toggle('is-active');
				tabContent.classList.toggle('is-active');
			})
		});

	}
});